/**
 * 간편견적 상수
 */
export const HCostConst: any = {
  //----------------------------------
  // 공통
  //----------------------------------
  //----------------------------------
  // 화면 변수
  //----------------------------------
  // 레이블
  label: {
    APPLY: "적용",
    CANCEL: "취소",
  },
  //----------------------------------
  // 데이터 변수
  //----------------------------------
  // 모델 용도
  modelUse: {
    HCOST: "간편견적",
    FBN: "수익성분석",
  },
  // 인입 경로
  inflowType: {
    HCOST: "간편견적",
    WIRELINE: "유선상담",
    HANDWORK: "직접입력",
    HCOUNSEL: "시공상담",
  },
  // 공개여부
  published: {
    PUBLISHED: "공개",
    UNPUBLISHED: "비공개",
  },
  // 모드
  hcostMode: {
    BIGINNER: "초급자",
    INTERMEDIATE: "중급자",
    MAINTENANCE: "유지보수",
  },
  // 투자 비용 형태
  costsType: {
    LABEL: "투자비용",
    INDIVISUAL: "개인투자",
    SUBSIDY: "정부지원사업",
    FINANCING: "정부융자사업",
  },
  // 구조
  struct: {
    LABEL: "구조",
    SINGLE: "단동형",
    INTERLOCK_CYLINDER: "원연동형",
    INTERLOCK_PRISM: "각연동형",
    INTERLOCK_POSMAC: "포즈맥연동형",
  },
  // 중수
  level: {
    LABEL: "중수",
    LEVEL1: "1중",
    LEVEL2: "2중",
    LEVEL3: "3중",
  },
  // 폭
  width: {
    LABEL: "폭",
  },
  // 길이
  length: {
    LABEL: "길이",
  },
  // 동수
  buildingNumber: {
    LABEL: "동수",
  },
  // 길이
  area: {
    LABEL: "면적",
  },
  // 길이
  pyeong: {
    LABEL: "평",
  },
  // 용도 및 작물
  usageAndCrop: {
    LABEL: "용도및작물",
    NONE: "선택안함",
    USAGE_07_SINGLE_3: "내재해 07-단동-3",
    USAGE_10_SINGLE_5: "내재해 10-단동-5",
    USAGE_FISHERY: "양어장(양식장/수족관)",
    USAGE_WAREHOUSE_SINGLE: "단동 창고",
    USAGE_SALE_INTERLOCK: "판매장연동",
    USAGE_NUTRIENT_STRAWBERRY_SINGLE: "딸기 양액재배 단동",
    USAGE_HYDROPONICS_LETTUCE_INTERLOCK: "상추 수경재배 연동",
    USAGE_SMARTFARM_TOMATO_INTERLOCK: "토마토 양액재배 연동",
    CROP_FRUIT: "과채류",
    CROP_LEAFTY: "엽채류",
    CROP_ROOT: "근채류",
    CROP_FRUIT_TREE: "과수",
    CROP_FLOWER: "화훼",
  },
  // 기초피복
  cover: {
    LABEL: "기초피복",
    VINIYL: "비닐",
    VINIYL_PREMIUM: "고급비닐",
    LAGGING: "보온피복",
    QUILTING: "다겹보온피복",
    SHADENET: "차광망",
  },
  // 개폐형태
  switchType: {
    LABEL: "개폐형태",
    NONE: "없음",
    MANUAL: "수동",
    POWER_SEMI: "동력+반자동제어",
    POWER_AUTO: "동력+자동제어",
  },
  // 천창시설
  skylight: {
    LABEL: "천창시설",
    NONE: "없음",
    BASIC: "기본형 천창",
    RACK_PINION_ONE: "랙앤피니언_편개형",
    RACK_PINION_BOTH: "랙앤피니언_양개형",
  },
  // 환기시설
  vent: {
    LABEL: "환기시설",
    EXAHUST_ENDPIECE_FAN: "앞뒤면 배기팬",
    EXHAUST_ROOF_FAN: "지붕 환기구",
    INSIDE_AIR_FLOW_FAN: "내부 유동팬",
  },
  // 커튼시설
  curtain: {
    LABEL: "커튼시설",
    NONE: "없음",
    CURTAIN_1: "1중 보온",
    CUARTAIN_2_SHADE: "2중 보온 + 차광",
    CUARTAIN_3_SHADE: "3중 보온 + 차광",
  },
  // 낸난방시설
  coolingHeating: {
    LABEL: "낸난방시설",
    HOT_FAN: "열풍기",
    BOILER: "보일러",
    DIRECT_HEAT_TUBE: "직열튜브",
    AIRCONDITIONER: "에어컨",
    UNDERGROUND_HEAT_EXCHNAGER: "지중열교환기",
  },
  // 수막시설
  wateringScreen: {
    LABEL: "수막시설",
    WATERING_SCREEN: "수막시설",
  },
  // 안개시설
  fog: {
    LABEL: "안개시설",
    FOG: "안개시설",
  },
  // 스프링클러시설
  sprinkler: {
    LABEL: "스프링클러시설",
    SPRINKLER: "스프링클러시설",
  },
  // 점적시설
  drip: {
    LABEL: "점적시설",
    DRIP: "점적시설",
  },
  // 양액
  nutrient: {
    LABEL: "양액",
    SYSTEM: "양액시스템",
    UPPER_BED: "고설베드",
    HEAT: "근권난방(배관)",
  },
  // 자동방제시스템
  autoPestControl: {
    LABEL: "자동방제시스템",
    AUTO_PEST_CONTROL: "자동방제시스템",
  },
  // CO2시설
  co2: {
    LABEL: "CO2시설",
    CO2: "CO2시설",
  },
  // 스마트팜시설
  smartfarm: {
    LABEL: "스마트팜시설",
    BASIC: "기본",
    HEIGHER: "고급",
    HEIGHEST: "최고급",
  },
  // 실내양식장시설
  fishery: {
    LABEL: "실내양식장시설",
    FISHERY: "실내양식장시설",
  },
  // 아쿠아포닉스시설
  aquaponics: {
    LABEL: "아쿠아포닉스시설",
    AQUAPONICS: "아쿠아포닉스시설",
  },
  // 균상다이/선반시설
  rack: {
    LABEL: "균상다이/선반시설",
    RACK: "균상다이/선반시설",
  },
  // 운반레일시설
  rail: {
    LABEL: "운반레일시설",
    RAIL: "운반레일시설",
  },
  // 작업동
  work: {
    LABEL: "작업동",
    WORK: "작업동",
  },
  // 바닥콘크리트
  floorConcrete: {
    LABEL: "바닥콘크리트",
    FlOOR_CONCRETE: "바닥콘크리트",
  },
  // 세면장+화장실
  washroom: {
    LABEL: "세면장+화장실",
    WASHROOM: "세면장+화장실",
  },
  // 정화조
  septicTank: {
    LABEL: "정화조",
    SEPTIC_TANK: "정화조",
  },
  // 관정
  mainpipe: {
    LABEL: "관정",
    SMALL: "소공",
    LARGE: "대공",
  },
  // 컨테이너
  container: {
    LABEL: "컨테이너",
    CONTAINER_3: "3*3m",
    CONTAINER_6: "3*6m",
    CONTAINER_9: "3*9m",
  },
  // 모델 유형
  modelCat: [
    {
      text: "단동 비닐하우스",
      value: "단동 비닐하우스",
    },
    {
      text: "연동 비닐하우스",
      value: "연동 비닐하우스",
    },
    {
      text: "유리 온실",
      value: "유리 온실",
    },
  ],

  //목록 유형
  searchType: {
    Counsel: "S01",
    Brokerage: "S02",
  },
} as const;
